import { z } from "zod";
import { IdempotencyKeySchema, IdSchema, IsoDateTimeSchema } from "./primitives.js";
export const CreateEncounterFollowUpTaskRequestSchema = z
    .object({
    siteId: IdSchema,
    patientId: IdSchema,
    summary: z.string().trim().min(1).max(2_000),
    dueAt: IsoDateTimeSchema,
    /** Omission explicitly assigns this task to the authenticated clinician. */
    ownerUserId: IdSchema.optional(),
    escalationAt: IsoDateTimeSchema.optional(),
    idempotencyKey: IdempotencyKeySchema,
})
    .strict()
    .superRefine((value, context) => {
    if (value.escalationAt && Date.parse(value.escalationAt) < Date.parse(value.dueAt)) {
        context.addIssue({
            code: "custom",
            path: ["escalationAt"],
            message: "Escalation cannot precede the due time",
        });
    }
});
export const EncounterFollowUpTasksQuerySchema = z
    .object({ siteId: IdSchema, patientId: IdSchema })
    .strict();
export const EncounterFollowUpTaskSchema = z
    .object({
    id: IdSchema,
    encounterId: IdSchema,
    patientId: IdSchema,
    ownerUserId: IdSchema,
    summary: z.string().trim().min(1).max(2_000),
    dueAt: IsoDateTimeSchema,
    escalationAt: IsoDateTimeSchema.optional(),
    status: z.enum(["open", "in_progress", "completed", "cancelled", "overdue"]),
    createdAt: IsoDateTimeSchema,
})
    .strict();
export const EncounterFollowUpTasksSchema = z.array(EncounterFollowUpTaskSchema).max(200);
//# sourceMappingURL=encounter-follow-up.js.map